export enum ActivityStatusCodes {
  CREATED = 'CREATED',
  COMPLETE = 'COMPLETE',
  IN_PROGRESS = 'IN_PROGRESS',
}
